<template>
    <div>
        <div class="main-content-iam-page">
            <div class="left-side-iam-page">
                <h6>{{ $t("Identity and Access Management (IAM)") }}</h6>
                <h6 class="dashboard-text" 
                    @click="gotoIAMDashboard"
                    :class="{ 'route-active': this.$route.path === '/iam-dashboard/'}"
                    >
                    {{ $t("Dashboard") }}
                </h6>
                <el-collapse @change="() => {}">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <i
                                class="
                                    header-icon
                                    nova-carot-down
                                    iam-down-icon
                                "
                            ></i>
                            Access management
                        </template>
                        <router-link
                            :to="{ name: `iam-user` }"
                            class="iam-links"
                            :class="{ 'route-active': this.$route.path === '/iam-dashboard/iam-user'}"
                            >User</router-link
                        >
                        <router-link
                            :to="{ name: `iamuser-group` }"
                            class="iam-links"
                            :class="{ 'route-active': this.$route.path === '/iam-dashboard/iamuser-group'}"
                            >User Groups</router-link
                        >
                        <!-- <router-link :to="{name:'iam-create-group'}" class="iam-links">User Groups</router-link> -->
                        <router-link :to="{ name: `iam-roles` }" 
                            class="iam-links"
                            :class="{ 'route-active': this.$route.path === '/iam-dashboard/iam-roles'}"
                            >Roles</router-link>
                        <router-link to="" class="iam-links"
                            >Policies</router-link
                        >
                        <router-link to="" class="iam-links">Teams</router-link>
                        <router-link to="" class="iam-links"
                            >Indentity Providers</router-link
                        >
                        <router-link to="" class="iam-links"
                            >Account Settings</router-link
                        >
                    </el-collapse-item>
                </el-collapse>
                <el-collapse @change="() => {}">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <i
                                class="
                                    header-icon
                                    nova-carot-down
                                    iam-down-icon
                                "
                            ></i>
                            Team management
                        </template>
                        <router-link to="" class="iam-links">User</router-link>
                        <router-link to="" class="iam-links"
                            >User Groups</router-link
                        >
                        <router-link to="" class="iam-links">Roles</router-link>
                        <router-link to="" class="iam-links"
                            >Policies</router-link
                        >
                        <router-link to="" class="iam-links">Teams</router-link>
                        <router-link to="" class="iam-links"
                            >Indentity Providers</router-link
                        >
                        <router-link to="" class="iam-links"
                            >Account Settings</router-link
                        >
                    </el-collapse-item>
                </el-collapse>
                <el-collapse @change="() => {}">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <i
                                class="
                                    header-icon
                                    nova-carot-down
                                    iam-down-icon
                                "
                            ></i>
                            Publications
                        </template>
                        <router-link to="" class="iam-links">User</router-link>
                        <router-link to="" class="iam-links"
                            >User Groups</router-link
                        >
                        <router-link to="" class="iam-links">Roles</router-link>
                        <router-link to="" class="iam-links"
                            >Policies</router-link
                        >
                        <router-link to="" class="iam-links">Teams</router-link>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="right-side-iam-page">
                <router-view
                    v-if="currentOrganisation"
                    :allOrgnisations="allOrgnisations"
                    :currentOrganisation="currentOrganisation"
                >
                </router-view>
                <template v-else>Loading...</template>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserProfile, getOrganisation } from "@/libs/api/api";
import { mapGetters } from "vuex";
import constants from "@/libs/constant/constants";
import { message, errorHandler, logout } from "@/libs/helper";
import pageRoutes from "@/libs/constant/pageRoutes";
export default {
    name: "IAM",
    data() {
        return {
            currentOrganisation: null,
            metaList: [],
            currentOrgFullDetails: {},
            allOrgnisations: [],
            orgTeams: [],
        };
    },
    components: {},
    async beforeCreate() {
        const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });

        getUserProfile({})
            .then((response) => {
                // set active profile in local storage
                if (response && (response.id || response._id)) {
                    localStorage.setItem(
                        "activeProfile",
                        response.id || response._id
                    );
                    this.$store.dispatch("setSelectedAccount", response || {});
                }
                loading.close();
            })
            .catch((error) => {
                loading.close();
                message(
                    this,
                    constants.messageType.ERROR,
                    errorHandler(error, logout.bind(this, this))
                );
            });
    },
    async created() {
        await this.fetchOrganisations();
    },
    computed: {
        ...mapGetters({
            userInformation: constants.getters.GET_USER_INFORMATION,
            organisationWithoutCollaborator:
                constants.getters.GET_ORGANSIATION_WITHOUT_COLLABORATOR,
            selectedAccount: constants.getters.GET_SELECTED_ACCOUNT,
            refreshOrganisationList: "getRefreshOrganisationList",
        }),
    },
    methods: {
        gotoIAMDashboard() {
            this.$router.push({name: pageRoutes.IAMMainDashboard}) 
        },
        //fetch the list of organisations
        async fetchOrganisations() {
            await getOrganisation()
                .then(async (response) => {
                    // initialise
                    (this.metaList = response || []),
                        (this.allOrgnisations = response || []);
                    this.currentOrganisation = response && response[0];
                    // set list in store
                    let owners = response.filter(
                        (org) =>
                            org.role === constants.ORGANISATION_RIGHTS.OWNER
                    );
                    this.$store.dispatch("setOrganisations", owners);
                })
                .catch((error) => {
                    message(
                        this,
                        constants.messageType.ERROR,
                        errorHandler(error, logout.bind(this, this))
                    );
                });
        },
    },
};
</script>
<style lang='scss'>
@import "@/styles/index.scss";
@import "@/styles/accura-portal.scss";
.main-content-iam-page {
    // padding-top:61px;
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: auto auto;
}
.left-side-iam-page {
    width: 20vw;
    height: auto;
    // border-right: 1px solid #707070;
    border-right: 3px solid #e0e0e0;
    display: inline-block;
    h6 {
        margin: 10px 20px;
        font-size: 20px;
        color: #242424;
        border-bottom: 1px solid;
        padding: 2% 1% 5% 0;
    }
    .dashboard-text {
        font-size: 16px;
        border: none;
        cursor: pointer;
        color: #242424;
    }
    .el-collapse {
        border: none;

        .el-collapse-item {
            padding: 0 20px;
            border: none;
            .el-collapse-item__header {
                border: none;
                font-size: 16px;
                color: #242424;
                font-weight: 600;
            }
            .el-collapse-item__header i {
                transition: transform 0.3s, -webkit-transform 0.3s;
            }
            .el-collapse-item__header.is-active {
                border: none;
            }
            .el-collapse-item__wrap {
                border: none;
                padding: 0 9%;
            }
            .iam-links {
                font-size: 16px;
                color: #242424;
                display: block;
            }
        }

        .el-icon-arrow-right {
            display: none;
        }

        // .el-icon-arrow-right:before{
        //     content: "\E790";
        // }
        // .el-collapse-item__arrow.is-active{
        //     transform: rotate(180deg);
        // }
        .el-collapse-item__header.is-active i {
            transform: rotate(180deg);
            transition: transform 0.3s, -webkit-transform 0.3s;
        }
        .nova-carot-down.iam-down-icon {
            margin: 0 2%;
        }
        .nova-carot-down.iam-down-icon:before {
            font-size: 10px;
        }
    }
    .route-active {
        color: $cornflower-blue !important;
    }
}
.right-side-iam-page {
    width: 78vw;
    display: inline-block;
    height: auto;
    padding-left: 15px;
    padding-bottom: 100px
}
</style>